import { Serializable } from '@/models/core/serializable';
import { GEnum } from '@/constants/enum.defination';

export class StatisticsFilterParam implements Serializable<StatisticsFilterParam> {
  grade: number = 0;
  schoolClassID: number = 0;
  schoolClassName: string = '';
  tagIDs: number[] = [];
  tagContents: string[] = [];
  evalSettingID: number = 0;
  evalSettingName: string = '';

  constructor() {
    this.grade = 0;
    this.schoolClassID = 0;
    this.schoolClassName = '';
    this.tagIDs = [];
    this.tagContents = [];
    this.evalSettingID = 0;
    this.evalSettingName = '';
  }

  deserialize(input: any): StatisticsFilterParam {
    this.grade = input.grade;
    this.schoolClassID = input.schoolClassID;
    this.schoolClassName = input.schoolClassName;
    this.tagIDs = input.tagIDs;
    this.tagContents = input.tagContents;
    this.evalSettingID = input.evalSettingID;
    this.evalSettingName = input.evalSettingName;

    return this;
  }

  get isDefaultValue(): boolean {
    return (
      this.grade === 0 &&
      this.schoolClassID === 0 &&
      this.tagIDs.length === 0 &&
      (this.evalSettingID === 0 || this.evalSettingID === undefined)//コースをクリアした場合にはundefinedが返るため
    );
  }

  get targetType(): GEnum.TargetType {
    if (this.grade === 0 && this.schoolClassID === 0) {
      return GEnum.TargetType.None;
    } else if (this.grade > 0 && this.schoolClassID === 0) {
      return GEnum.TargetType.Grade;
    }
    return GEnum.TargetType.Class;
  }

  get targetID(): number {
    if (this.grade === 0 && this.schoolClassID === 0) {
      return 0;
    } else if (this.grade > 0 && this.schoolClassID === 0) {
      return this.grade;
    }
    return this.schoolClassID;
  }

  get selectedCommaTagIDs(): string {
    return this.tagIDs.join(',');
  }
}
